import { AddPromotionModel, PromotionModelBase } from "@truckdown/promotions";
import { IValidator } from "../../Validation/IValidator";

interface IPropertyValidator {
    key: string;
    validator: () => boolean;
    message: () => string;
}

export class PromotionValidator implements IValidator {
    constructor(promotion: PromotionModelBase) {
        this._promotion = promotion;
        this._validators = this.getValidators();
    }

    private _promotion: PromotionModelBase;
    private _validators: IPropertyValidator[];
    private getValidators(): IPropertyValidator[] {
        return [
            {
                key: "title",
                message: () => this.validatePromotionTitleMessage(this._promotion.title),
                validator: () => this.validatePromotionTitle(this._promotion.title)
            },
            {
                key: "message",
                message: () => this.validatePromotionMessageMessage(this._promotion.message),
                validator: () => this.validatePromotionMessage(this._promotion.message)
            },
            {
                key: "expiryDate",
                message: () => this.validatePromotionExpiryDateMessage(this._promotion.expiry),
                validator: () => this.validatePromotionExpiryDate(this._promotion.expiry)
            },
            {
                key: "locationIds",
                message: () => this.validatePromotionLocationMessage(this._promotion),
                validator: () => this.validatePromotionLocation(this._promotion)
            },
        ];
    }

    private validatePromotionTitleMessage(title: string): string {
        if (!title || title.trim().length < 1) {
            return "Title is required.";
        }
        if (title.trim().length > 150) {
            return "Title is too long.";
        }
        return "";
    }

    private validatePromotionTitle(title: string): boolean {
        let isValid = false;
        if (title && title.trim().length > 0 && title.trim().length <= 150) {
            isValid = true;
        }

        return isValid;
    }

    private validatePromotionLocationMessage(promo: PromotionModelBase): string {
        if (!promo.applyToAllLocations && promo.locationIds.length == 0) {
            return "Please select at least one location.";
        }
        return "";
    }

    private validatePromotionLocation(promo: PromotionModelBase): boolean {
        if (!promo.applyToAllLocations && promo.locationIds.length == 0) {
            return false;
        }

        return true;
    }

    private validatePromotionMessage(message: string): boolean {
        let isValid = false;
        if (message && message.trim().length > 0 && message.trim().length < 501) {
            isValid = true;
        }

        return isValid;
    }

    private validatePromotionMessageMessage(message: string): string {
        if (!message || message.trim().length < 1) {
            return "Message is required.";
        }
        if (message.trim().length > 500) {
            return "Message is too long.";
        }
        return "";
    }

    private validatePromotionExpiryDateMessage(expiryDate: Date | undefined): string {
        if (expiryDate) {
            var date = new Date(expiryDate);
            if (date > new Date()) {
                return '';
            }
            return 'Expiry must be a future date.';
        }

        return '';
    }

    private validatePromotionExpiryDate(expiryDate: Date | undefined): boolean {
        if (expiryDate) {
            console.log('Expiry value: ' + expiryDate);

            var date = new Date(expiryDate);
            var current = new Date();

            console.log('Expiry: ' + date);
            console.log('Current: ' + current);
            if (date > current) {
                return true;
            }
            return false;
        }

        return true;
    }

    reset() {
        this.errors = {};
    }

    validate(key?: string): boolean {
        if (key) {
            let validator = this._validators.find(v => v.key == key);
            if (validator) {
                const isValid = validator.validator();
                if (!isValid) {
                    this.errors[key] = validator.message();
                } else {
                    delete this.errors[key];
                }
                return isValid;
            }
            return true;
        } else {
            let isValid = true;
            for (let i = 0; i < this._validators.length; i++) {
                let v = this._validators[i];
                if (!v.validator()) {
                    isValid = false;
                    delete this.errors[v.key];
                    this.errors[v.key] = v.message();
                } else {
                    delete this.errors[v.key];
                }
            }
            return isValid;
        }
    }

    errors: { [key: string]: string } = {};
}